import React from 'react'
import { useIntl } from 'react-intl'
import { useTimer } from 'react-timer-hook'
import { Box } from '@mui/material'

import { capitalize } from '../../../../../utils/functions'
import { CoursePromotionState } from '../../../../../features/types'
import {
    discountBox,
    flexBetween,
    promoText,
    textCenter,
    time,
    timeTitle,
    timerBox,
} from '../style'
// import { kk, ru } from 'date-fns/locale'
// import format from 'date-fns/format'

interface Props {
    promotion: CoursePromotionState
    onExpire?: () => void
}
const PromoTimer: React.FC<Props> = ({ promotion, onExpire }) => {
    const { formatMessage } = useIntl()
    //const dateToString = formatWithOptions({ locale: kk }, 'd MMMM yyyy')
    // const discountDate = format(new Date(promotion.endTime), 'do MMMM', {
    //     locale: locale === 'kz' ? kk : ru,
    // })
    const expiryTimestamp = new Date()
    const timeDifferenceMs =
        new Date(promotion.endTime).getTime() - expiryTimestamp.getTime()
    const timeDifferenceSecs = Math.floor(timeDifferenceMs / 1000)

    expiryTimestamp.setSeconds(
        expiryTimestamp.getSeconds() + timeDifferenceSecs,
    )

    const { seconds, minutes, hours, days } = useTimer({
        expiryTimestamp,
        onExpire,
    })

    return (
        <Box sx={timerBox}>
            <Box sx={discountBox}>-{promotion.discount}%</Box>

            <Box sx={promoText}>{formatMessage({ id: 'promo' })}</Box>

            {/* <Box
                sx={{ fontSize: '14px' }}
                mb={1}
            >
                {discountDate}
            </Box> */}

            <Box sx={{ ...flexBetween, ...textCenter }}>
                <Box>
                    <Box sx={time}>{days}</Box>

                    <Box sx={timeTitle}>
                        {capitalize(formatMessage({ id: 'day' }))}
                    </Box>
                </Box>

                <Box>:</Box>

                <Box>
                    <Box sx={time}>{hours}</Box>

                    <Box sx={timeTitle}>
                        {capitalize(formatMessage({ id: 'hours' }))}
                    </Box>
                </Box>

                <Box>:</Box>

                <Box>
                    <Box sx={time}>{minutes}</Box>

                    <Box sx={timeTitle}>
                        {capitalize(formatMessage({ id: 'minutes' }))}
                    </Box>
                </Box>

                <Box>:</Box>

                <Box>
                    <Box sx={time}>{seconds}</Box>

                    <Box sx={timeTitle}>
                        {capitalize(formatMessage({ id: 'second' }))}
                    </Box>
                </Box>
            </Box>
        </Box>
    )
}

export default PromoTimer
